// hooks/useFileUpload.ts
import { useState } from "react";
import axios from "axios";
import { getLocalToken } from "@utils/helpers";
import { getErrorMessage } from "@utils/error";

export const useFileUpload = (uploadUrl, responseType = "json") => {
  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState(null);

  const uploadFile = async (payload) => {
    setIsUploading(true);
    setProgress(0);
    setError(null);

    try {
      const response = await axios.post(uploadUrl, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: getLocalToken(),
        },
        responseType,
        onUploadProgress: (event) => {
          const percent = Math.round((event.loaded * 100) / event.total);
          setProgress(percent);
        },
      });

      return response.data;
    } catch (err) {
      setError(getErrorMessage(err, "Upload failed"));
      return err.response.data;
    } finally {
      setIsUploading(false);
    }
  };

  return { uploadFile, progress, isUploading, error };
};
